var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 3,
    viewBox: "0 0 10 3",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.999878L1.50015 0.856415C0.923055 0.832759 0.591421 1.50463 0.961178 1.94834C1.09574 2.10981 1.29863 2.19829 1.50852 2.18704L5 1.99988L8.49148 2.18704C8.70137 2.19829 8.90426 2.10981 9.03882 1.94834C9.40858 1.50463 9.07695 0.832759 8.49985 0.856415L5 0.999878Z",
    fill: "#113D18"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dash.3804b46f.svg";
export { ForwardRef as ReactComponent };